import type { PieceName, Square } from "src/api";

import type { World } from "../../../../render/world/World";
import { WorldObject } from "../../../../render/world/WorldObject";
import { kCenteralLoader } from "../../../../singletons/CentralLoader";
import type { BoardUpdate } from "../../updates/BoardUpdate";
import type { BoardWorldObject } from "../../updates/BoardWorldObject";
import { ScrapHeap } from "./ScrapHeap";

export class BoardScrapHeaps extends WorldObject implements BoardWorldObject {
  private readonly scrapHeapBySquare = new Map<Square, ScrapHeap>();
  private readonly world: World;

  constructor(world: World) {
    super();

    this.world = world;
  }

  onBoardUpdate(boardUpdate: BoardUpdate) {
    const seenSquares = new Set<Square>();
    for (const squareFacts of boardUpdate.facts.squares.values()) {
      const heapFacts = squareFacts.heap;
      if (!heapFacts) continue;

      const square = squareFacts.square;
      seenSquares.add(square);
      const existing = this.scrapHeapBySquare.get(square);
      if (existing?.scrappedPieceName === heapFacts.wreck) continue;

      if (existing) this.despawn(square, existing);
      this.spawn(heapFacts.wreck, square);
    }

    for (const [square, scrapHeap] of [...this.scrapHeapBySquare]) {
      if (!seenSquares.has(square)) this.despawn(square, scrapHeap);
    }
  }

  isBoardUpdateFinished() {
    return true;
  }

  dispose() {
    for (const [square, scrapHeap] of [...this.scrapHeapBySquare])
      this.despawn(square, scrapHeap);
  }

  private spawn(wreck: PieceName, square: Square) {
    const gltf = kCenteralLoader
      .getPrimaryFactionResource(wreck, null)
      .getResource();
    const scrapHeap = new ScrapHeap(wreck, gltf, square);
    this.world.add(scrapHeap);
    this.scrapHeapBySquare.set(square, scrapHeap);
  }

  private despawn(square: Square, scrapHeap: ScrapHeap) {
    this.world.removeAndDispose(scrapHeap);
    this.scrapHeapBySquare.delete(square);
  }
}
